"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reflux = _interopRequireDefault(require("reflux"));

var _DataStore = _interopRequireDefault(require("../../../KESI2/Stores/DataStore2"));

var _strings = require("../../../../config/strings");

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _CordovaExternalWebsite = _interopRequireDefault(require("./CordovaExternalWebsite.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var COMMANDS = {
  GET_DATA: 'get_data',
  SET_DATA: 'set_data',
  REMOVE_DATA: 'remove_data',
  SET_TITLE: 'set_title',
  LOAD_ERROR: 'load_error',
  CLOSE_DIALOG: 'close',
  CLOSE_AND_CHECK: 'close_and_check'
};
var COMMANDS_TO_IFRAME = {
  REQUESTED_VALUE: 'requested_value'
};
var URL_PARAM_START = '${';
var URL_PARAM_END = '}';
var SUPPORTED_PARAMS = {
  ACTIVATED_FEATURES: 'activated_features',
  APP_HOST: 'app_host',
  APP_NAME: 'app_name',
  APP_PASSWORD: 'app_password',
  APP_USERNAME: 'app_username',
  APP_VERSION: 'app_version',
  CURRENT_THEME: 'current_theme',
  DEVICE_UUID: 'deviceuuid',
  FEATURE_USERID: 'userid',
  FEATURE_NICKNAME: 'nickname',
  FEATURE_REQUEST_CODE: 'request_code',
  LANGUAGE: 'lang',
  DATA: 'data'
};
var SECURED_PARAMS = [SUPPORTED_PARAMS.ACTIVATED_FEATURES, SUPPORTED_PARAMS.APP_HOST, SUPPORTED_PARAMS.APP_NAME, SUPPORTED_PARAMS.APP_VERSION, SUPPORTED_PARAMS.APP_PASSWORD, SUPPORTED_PARAMS.APP_USERNAME, SUPPORTED_PARAMS.DEVICE_UUID, SUPPORTED_PARAMS.FEATURE_USERID, SUPPORTED_PARAMS.FEATURE_NICKNAME, SUPPORTED_PARAMS.FEATURE_REQUEST_CODE // SUPPORTED_PARAMS.DATA
];
var MAX_LOAD_DURATION = 10000; // in ms

var CordovaExternalWebsite = /*#__PURE__*/function (_Reflux$Component) {
  (0, _inherits2["default"])(CordovaExternalWebsite, _Reflux$Component);

  var _super = _createSuper(CordovaExternalWebsite);

  function CordovaExternalWebsite(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CordovaExternalWebsite);
    _this = _super.call(this, props); // this is just a placeholder for a better coding experience

    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLoaded", function () {
      console.log('iframe loaded (CordovaExternalWebsite)');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLoadError", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var defaultOnLoadError, buttonOk, buttonTryAgain;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('load error');

              if (_this.errorTimer) {
                _this.errorTimer.invalidate();

                _this.errorTimer = null;
              }

              _this.setState({
                initialized: false,
                loaded: false
              });

              console.log('iframerror');

              defaultOnLoadError = function defaultOnLoadError() {
                _NavigationManager["default"].goBack();
              };

              buttonOk = {
                label: (0, _strings.getString)('OK'),
                callback: _this.props.onLoadError || defaultOnLoadError
              };
              buttonTryAgain = {
                label: (0, _strings.getString)('TRY_AGAIN'),
                callback: function () {
                  var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this.init(_this.props);

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function callback() {
                    return _callback.apply(this, arguments);
                  }

                  return callback;
                }()
              };

              if (_this.props.onLoadErrorBeforeAlert) {
                _this.props.onLoadErrorBeforeAlert();
              }

              (0, _AlertHelper.showAlertWithOptions)({
                message: (0, _strings.getString)('ERROR_LOADING_CONTENT'),
                buttons: [buttonTryAgain, buttonOk],
                size: 'large',
                showCloseButton: false
              }); // showWideAlert(getString('ERROR_LOADING_CONTENT'), null, false, true, [buttonTryAgain, buttonOk])

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onReceiveMessage", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(evt) {
        var data, command, val;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('got message: ', evt, evt.data);

                if (_this.state.initialized) {
                  _context3.next = 4;
                  break;
                }

                console.log('not accepting message in unintialized state');
                return _context3.abrupt("return");

              case 4:
                // any message received from iframe is a notification about a loaded iframe so let's invalidate the errorTimer
                _this.errorTimer.invalidate();

                _context3.prev = 5;
                data = JSON.parse(evt.data);

                if (data) {
                  console.log({
                    data: data
                  });
                }

                if (!data.command) {
                  _context3.next = 13;
                  break;
                }

                command = data.command;
                val = data.value; // this variable must not be named 'value' as safari has some difficulties. WHY???

                _context3.next = 13;
                return _this.executeCommand(command, val);

              case 13:
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](5);
                // just go on
                console.error(_context3.t0);

              case 18:
                // any message received means the site is loaded
                _this.setState({
                  loaded: true
                });

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[5, 15]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _this.state = {
      url: props.url,
      initialized: true,
      loaded: false
    };
    _this.id = _StringHelper["default"].createUuid();
    _this.appInfo = null;
    _this.users = {};
    _this.errorTimer = null;
    _this.store = _ThemeStore["default"];
    _this.storeKeys = ['currentTheme'];

    _this.init(props);

    return _this;
  }

  (0, _createClass2["default"])(CordovaExternalWebsite, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url !== this.props.url) {
        this.init(nextProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.errorTimer) {
        this.errorTimer.invalidate();
      }

      window.removeEventListener('message', this.onReceiveMessage);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(CordovaExternalWebsite.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getStyle",
    // async getAppInfo () {
    //   try {
    //     if (!this.appInfo) {
    //       this.appInfo = await getAppInfo()
    //     }
    //     return Promise.resolve(this.appInfo)
    //   }
    //   catch (error) {
    //     return Promise.reject(error)
    //   }
    // }
    // async getUser (featureName) {
    //   try {
    //     if (!this.users[featureName]) {
    //       this.users[featureName] = await getUser(featureName)
    //     }
    //     return Promise.resolve(this.users[featureName])
    //   } catch (error) {
    //     return Promise.reject(error)
    //   }
    // }
    value: function getStyle() {
      if (this.state.loaded || !this.props.sendsMessages) {
        if (this.state.loaded || !this.props.sendsMessages) {
          return {};
        }

        return {
          opacity: 0
        };
      }
    }
  }, {
    key: "executeCommand",
    value: function () {
      var _executeCommand = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(command, val) {
        var path, value, _path, innerValue, _path2;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (command === COMMANDS.SET_TITLE) {
                  this.props.setTitle(val);
                }

                if (command === COMMANDS.LOAD_ERROR) {
                  this.onLoadError();
                }

                if (!(command === COMMANDS.GET_DATA)) {
                  _context4.next = 9;
                  break;
                }

                path = val.path;
                _context4.next = 6;
                return _DataStore["default"].getElementByPath(path);

              case 6:
                value = _context4.sent;
                console.log("got data for path ".concat(path, ": ").concat((0, _stringify["default"])(value)));
                this.sendMessageToIframe(COMMANDS_TO_IFRAME.REQUESTED_VALUE, {
                  path: path,
                  value: value
                });

              case 9:
                if (!(command === COMMANDS.SET_DATA)) {
                  _context4.next = 15;
                  break;
                }

                _path = val.path;
                innerValue = val.value;
                console.log("setting data for path ".concat(_path, " with value ").concat(innerValue));
                _context4.next = 15;
                return _DataStore["default"].setSingleData(_path, innerValue);

              case 15:
                if (!(command === COMMANDS.REMOVE_DATA)) {
                  _context4.next = 19;
                  break;
                }

                _path2 = val.path;
                _context4.next = 19;
                return _DataStore["default"].removeData(_path2);

              case 19:
                if (command === COMMANDS.CLOSE_DIALOG) {
                  this.props.closeFunc();
                }

                if (command === COMMANDS.CLOSE_AND_CHECK) {
                  this.props.closeAndRetryFunc();
                }

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function executeCommand(_x2, _x3) {
        return _executeCommand.apply(this, arguments);
      }

      return executeCommand;
    }()
  }, {
    key: "sendMessageToIframe",
    value: function sendMessageToIframe(command, value) {
      document.getElementById(this.id).contentWindow.postMessage((0, _stringify["default"])({
        command: command,
        value: value
      }), '*');
    }
  }, {
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(props) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.appInfo = null;
                this.users = {};

                if (this.errorTimer) {
                  this.errorTimer.invalidate();
                  this.errorTimer = null;
                }

                window.removeEventListener('message', this.onReceiveMessage); // const state = {
                //   initialized: true,
                //   url: props.url
                // }
                //
                // await timeout()
                // console.log({nextState: state})
                // this.setState(state)

                if (this.props.sendsMessages) {
                  window.addEventListener('message', this.onReceiveMessage);
                  this.startLoadTimer();
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function init(_x4) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "parseParametersInUrl",
    value: function parseParametersInUrl(url) {
      var collectedParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var startIndex = url.indexOf(URL_PARAM_START, index);

      if (startIndex < 0) {
        return collectedParams;
      }

      var endIndex = url.indexOf(URL_PARAM_END, startIndex + URL_PARAM_START.length);

      if (endIndex < 0) {
        (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
          message: 'Missing closing curly brace for url parameter'
        }); // showAlertInDebugMode('Missing closing curly brace for url parameter')

        return collectedParams;
      }

      var paramInUrl = url.substring(startIndex + URL_PARAM_START.length, endIndex);
      var command = paramInUrl;
      var args = [];
      var argsStartIndex = paramInUrl.indexOf('(');

      if (argsStartIndex >= 0) {
        command = paramInUrl.substring(0, argsStartIndex);
        var argsEndIndex = paramInUrl.indexOf(')', argsStartIndex + 1);
        args = paramInUrl.substring(argsStartIndex + 1, argsEndIndex).split(',');
        args = args.map(function (arg) {
          return arg.trim();
        });
      }

      var parsedParam = {
        COMMAND: command,
        ARGS: args,
        START: startIndex,
        END: endIndex
      };
      return this.parseParametersInUrl(url, collectedParams.concat(parsedParam), endIndex + 1);
    }
  }, {
    key: "replacePlaceholderInUrl",
    value: function () {
      var _replacePlaceholderInUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(url) {
        var _this2 = this;

        var params, isSecuredConnection, parametrizedUrl, promises, results;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = this.parseParametersInUrl(url);
                isSecuredConnection = url.startsWith('https://');
                parametrizedUrl = url;
                console.log({
                  params: params
                });
                promises = params.map( /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(param) {
                    var returnValue, command;
                    return _regenerator["default"].wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            returnValue = {
                              VALUE: 'null',
                              START: param.START,
                              END: param.END
                            };
                            command = param.COMMAND;

                            if (!((0, _values["default"])(SUPPORTED_PARAMS).indexOf(command) < 0)) {
                              _context6.next = 6;
                              break;
                            }

                            (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                              message: "Unsupported parameter in iframe url: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "]")
                            }); // showAlertInDebugMode(`Unsupported parameter in iframe url: ${command}${JSON.stringify(param.ARGS)}]`)

                            _context6.next = 52;
                            break;

                          case 6:
                            if (!(!isSecuredConnection && SECURED_PARAMS.indexOf(command >= 0))) {
                              _context6.next = 10;
                              break;
                            }

                            (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                              message: 'Sending secret parameters over an unsecured connection (not being https://) is not supported',
                              title: 'Warning'
                            }); // showAlertInDebugMode('Sending secret parameters over an unsecured connection (not being https://) is not supported', 'Warning')

                            _context6.next = 51;
                            break;

                          case 10:
                            if (!(command === SUPPORTED_PARAMS.ACTIVATED_FEATURES)) {
                              _context6.next = 13;
                              break;
                            }

                            _context6.next = 51;
                            break;

                          case 13:
                            if (!(command === SUPPORTED_PARAMS.APP_HOST)) {
                              _context6.next = 16;
                              break;
                            }

                            _context6.next = 51;
                            break;

                          case 16:
                            if (!(command === SUPPORTED_PARAMS.APP_NAME)) {
                              _context6.next = 19;
                              break;
                            }

                            _context6.next = 51;
                            break;

                          case 19:
                            if (!(command === SUPPORTED_PARAMS.APP_PASSWORD)) {
                              _context6.next = 22;
                              break;
                            }

                            _context6.next = 51;
                            break;

                          case 22:
                            if (!(command === SUPPORTED_PARAMS.APP_USERNAME)) {
                              _context6.next = 25;
                              break;
                            }

                            _context6.next = 51;
                            break;

                          case 25:
                            if (!(command === SUPPORTED_PARAMS.APP_VERSION)) {
                              _context6.next = 28;
                              break;
                            }

                            _context6.next = 51;
                            break;

                          case 28:
                            if (!(command === SUPPORTED_PARAMS.DEVICE_UUID)) {
                              _context6.next = 31;
                              break;
                            }

                            _context6.next = 51;
                            break;

                          case 31:
                            if (!(command === SUPPORTED_PARAMS.FEATURE_NICKNAME)) {
                              _context6.next = 35;
                              break;
                            }

                            if (param.ARGS.length < 1) {
                              (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                message: "Missing args in iframe parameter: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (expected 1)")
                              }); // showAlertInDebugMode(`Missing args in iframe parameter: ${command}${JSON.stringify(param.ARGS)}] (expected 1)`)
                            } else {
                                try {// const user = await this.getUser(param.ARGS[0])
                                  // console.log({user})
                                  // returnValue.VALUE = user.nickname
                                } catch (error) {
                                  (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                    message: "Couldn't retrieve info for iframe param: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (").concat(error, ")")
                                  }); // showAlertInDebugMode(`Couldn't retrieve info for iframe param: ${command}${JSON.stringify(param.ARGS)}] (${error})`)
                                }
                              }

                            _context6.next = 51;
                            break;

                          case 35:
                            if (!(command === SUPPORTED_PARAMS.FEATURE_USERID)) {
                              _context6.next = 39;
                              break;
                            }

                            if (param.ARGS.length < 1) {
                              (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                message: "Missing args in iframe parameter: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (expected 1)")
                              }); // showAlertInDebugMode(`Missing args in iframe parameter: ${command}${JSON.stringify(param.ARGS)}] (expected 1)`)
                            } else {
                                try {// const user = await this.getUser(param.ARGS[0])
                                  // console.log({user})
                                  // returnValue.VALUE = user.userId
                                } catch (error) {
                                  (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                    message: "Couldn't retrieve info for iframe param: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (").concat(error, ")")
                                  }); // showAlertInDebugMode(`Couldn't retrieve info for iframe param: ${command}${JSON.stringify(param.ARGS)}] (${error})`)
                                }
                              }

                            _context6.next = 51;
                            break;

                          case 39:
                            if (!(command === SUPPORTED_PARAMS.FEATURE_REQUEST_CODE)) {
                              _context6.next = 43;
                              break;
                            }

                            if (param.ARGS.length < 1) {
                              (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                message: "Missing args in iframe parameter: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (expected 1)")
                              }); // showAlertInDebugMode(`Missing args in iframe parameter: ${command}${JSON.stringify(param.ARGS)}] (expected 1)`)
                            } else {
                                try {// const user = await this.getUser(param.ARGS[0])
                                  // console.log({user})
                                  // returnValue.VALUE = user.activationCode
                                } catch (error) {
                                  (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                                    message: "Couldn't retrieve info for iframe param: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (").concat(error, ")")
                                  }); // showAlertInDebugMode(`Couldn't retrieve info for iframe param: ${command}${JSON.stringify(param.ARGS)}] (${error})`)
                                }
                              }

                            _context6.next = 51;
                            break;

                          case 43:
                            if (!(command === SUPPORTED_PARAMS.DATA)) {
                              _context6.next = 51;
                              break;
                            }

                            if (!(params.ARGS.length < 1)) {
                              _context6.next = 48;
                              break;
                            }

                            (0, _AlertHelper.showAlertWithOptionsInDebugMode)({
                              message: "Missing args in iframe parameter: ".concat(command).concat((0, _stringify["default"])(param.ARGS), "] (expected 1)")
                            }); // showAlertInDebugMode(`Missing args in iframe parameter: ${command}${JSON.stringify(param.ARGS)}] (expected 1)`)

                            _context6.next = 51;
                            break;

                          case 48:
                            _context6.next = 50;
                            return _DataStore["default"].getElementByPath(param.ARGS[0]);

                          case 50:
                            returnValue.VALUE = _context6.sent;

                          case 51:
                            // unsecured parameters
                            if (command === SUPPORTED_PARAMS.CURRENT_THEME) {
                              returnValue.VALUE = _this2.state.currentTheme;
                            } else if (command === SUPPORTED_PARAMS.LANGUAGE) {
                              // TODO: implement central store for current language in case we ever implement language switch
                              returnValue.VALUE = _config["default"].supportedLanguages[0];
                            }

                          case 52:
                            return _context6.abrupt("return", _promise["default"].resolve(returnValue));

                          case 53:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x6) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                _context7.next = 7;
                return _promise["default"].all(promises);

              case 7:
                results = _context7.sent.sort(function (paramValueA, paramValueB) {
                  return paramValueA.START - paramValueB.START;
                }).reverse();
                console.log({
                  results: results
                });
                results.forEach(function (result) {
                  parametrizedUrl = parametrizedUrl.substring(0, result.START) + result.VALUE + parametrizedUrl.substring(result.END + 1);
                });
                return _context7.abrupt("return", _promise["default"].resolve(parametrizedUrl));

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function replacePlaceholderInUrl(_x5) {
        return _replacePlaceholderInUrl.apply(this, arguments);
      }

      return replacePlaceholderInUrl;
    }()
  }, {
    key: "startLoadTimer",
    value: function () {
      var _startLoadTimer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.errorTimer = new _TimeoutHelper.InvalidatableTimeout(MAX_LOAD_DURATION); // timer is invalidated in onReceiveMessage

                _context8.prev = 1;
                _context8.next = 4;
                return this.errorTimer.wait();

              case 4:
                this.onLoadError();
                _context8.next = 9;
                break;

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](1);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 7]]);
      }));

      function startLoadTimer() {
        return _startLoadTimer.apply(this, arguments);
      }

      return startLoadTimer;
    }()
  }, {
    key: "render",
    value: function render() {
      console.log({
        ExternalWebsiteState: this.state
      });

      if (!this.state.initialized) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("iframe", {
        id: this.id,
        className: _CordovaExternalWebsite["default"].iframe,
        style: this.getStyle(),
        src: this.state.url,
        onLoad: this.onLoaded
      });
    }
  }]);
  return CordovaExternalWebsite;
}(_reflux["default"].Component);

CordovaExternalWebsite.propTypes = {
  url: _propTypes["default"].string.isRequired,
  sendsMessages: _propTypes["default"].bool.isRequired,
  setTitle: _propTypes["default"].func,
  onLoadError: _propTypes["default"].func,
  onLoadErrorBeforeAlert: _propTypes["default"].func,
  closeFunc: _propTypes["default"].func,
  closeAndRetryFunc: _propTypes["default"].func
};
CordovaExternalWebsite.defaultProps = {
  setTitle: function setTitle() {},
  onLoadError: null,
  onLoadErrorBeforeAlert: null,
  closeFunc: null,
  closeAndRetryFunc: null
};
var _default = CordovaExternalWebsite;
exports["default"] = _default;